
<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1>Research and Publication</h1>
        </div>
      </div>
    </div>
  </div>
</section>
  <ul class="breadcrumb">
    <li><a href="#">Academics</a></li>
    <li><i class="fa fa-angle-double-right"></i></li>
    <li>Research and Publication</li>
  </ul>
<section class="section-lg std-scholarship">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="inner-title"  >
          <h4>Research and Publication</h4>
         
        </div>
      </div>
      <div class="col-md-12 col-sm-12">
        <iframe src="https://drive.google.com/file/d/1x43d5D0t1gnVZTZyM8GIbFTkPiC0KX4K/preview" width="100%" height="650px"></iframe>
      </div>      
    </div>
  </div>
</section>
